import { ColDef, ValueGetterParams } from "ag-grid-community";
import { getCreditType } from "../utils/getCreditType";
import Typo from "@/src/components/atom/Typo";
import { getFormattedTimezoneDateWithOffset } from "@/src/hooks/useCompanyLocalDate";
import DATE_FORMAT_STRINGS from "@/src/constant/dateFormat";

export const usageHistoryColumns = [
  {
    headerClass: "ag-right-aligned-cell ag-header-hide",
    cellStyle: { textAlign: "center" },
    field: "createdAt",
    minWidth: 220,
    cellRenderer: (params: ValueGetterParams) => {
      const gmtOffset = params.data?.gmtOffset;

      return params.data.createdAt ? (
        <Typo typoType="b9r">
          {getFormattedTimezoneDateWithOffset({
            date: params.data.createdAt,
            gmtOffset,
            format: DATE_FORMAT_STRINGS.YYYY_MM_DD,
          })}
        </Typo>
      ) : (
        "-"
      );
    },
    sortable: true,
  },
  {
    headerClass: "ag-right-aligned-cell ag-header-hide",
    cellStyle: { textAlign: "center" },
    field: "creditType",
    minWidth: 180,
    cellRenderer: (params: ValueGetterParams) => {
      const t = params.data.t;

      return params.data?.credit ? (
        <Typo typoType="b9r">
          {t(getCreditType(params.data.credit.creditType))}
        </Typo>
      ) : (
        "-"
      );
    },
    sortable: false,
  },
  {
    headerClass: "ag-right-aligned-cell ag-header-hide",
    cellStyle: { textAlign: "center" },
    field: "count",
    minWidth: 180,
    cellRenderer: (params: ValueGetterParams) => {
      const usedCredit = params.data?.count;
      return usedCredit ? (
        <Typo typoType="b9r">{usedCredit.toLocaleString("ko-KR")}</Typo>
      ) : (
        "-"
      );
    },
    sortable: false,
  },
  {
    headerClass: "ag-right-aligned-cell ag-header-hide",
    cellStyle: { textAlign: "center" },
    field: "loadingNo",
    flex: 1,
    minWidth: 300,
    cellRenderer: (params: ValueGetterParams) => {
      return params.data?.payloadString ? (
        <Typo typoType="b9r">{params.data?.payloadString}</Typo>
      ) : (
        "-"
      );
    },
    sortable: false,
  },
] as ColDef[];
